module.exports = __webpack_public_path__ + "static/media/print.d223c98a.svg";